import { React, PT } from '@gasbuddy/react';
import { Text } from '@gasbuddy/react-components';
import style from './style.css';

function valueSorter(a, b) {
  return b.reward_value - a.reward_value;
}

export default function CategoryList({ className, onDetail, categories }) {
  return (
    <table className={className}>
      <tbody>
        {categories.sort(valueSorter).map(cat => (
          <tr key={cat.category} onClick={() => onDetail(cat)}>
            <td width="80%">
              {cat.category}
              {cat.detail && (
                <button
                  type="button"
                  className={style.linkButton}
                  onClick={(e) => {
                    e.preventDefault();
                    onDetail(cat);
                  }}
                >
                  more info...
                </button>
              )}
            </td>
            <td><Text color="teal">{cat.reward_text}</Text></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

CategoryList.propTypes = {
  className: PT.string.isRequired,
  onDetail: PT.func.isRequired,
  categories: PT.arrayOf(PT.shape({ category: PT.string })).isRequired,
};
